"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _MultiLayeredFigureModule = _interopRequireDefault(require("./../../scss/blocks/MultiLayeredFigure.module.scss"));
function MultiLayeredFigure({
  images = [],
  positions = ['center'],
  sizes = ['auto']
}) {
  const createValue = (list = [], type = '') => {
    let value = ``;
    for (let i = 0; i < list.length; i++) {
      if (type === 'image') {
        if (i === 0) {
          value += `url("${list[i]}")`;
        } else {
          value += `,url("${list[i]}")`;
        }
      } else {
        if (i === 0) {
          value += `${list[i]}`;
        } else {
          value += `,${list[i]}`;
        }
      }
    }
    return value;
  };
  const backgroundPositions = createValue(positions);
  const backgroundImages = createValue(images, 'image');
  const backgroundSizes = createValue(sizes);
  return /*#__PURE__*/_react.default.createElement("figure", {
    className: _MultiLayeredFigureModule.default['multi-layered-figure']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MultiLayeredFigureModule.default['multi-layered-figure__images'],
    style: {
      backgroundImage: backgroundImages,
      backgroundPosition: backgroundPositions,
      backgroundSize: backgroundSizes
    }
  }));
}
var _default = exports.default = MultiLayeredFigure;